import { KatapultElement, html } from './katapult-element';

import '@polymer/font-roboto/roboto.js';

import '../elements/katapult-auth/katapult-auth';

function _html(_strings, ...values) {
  // Get template for passed in content.
  const template = html(_strings, ...values);
  return html`
    <!-- Default Styling -->
    <style>
      :host {
        font-family: Roboto;
      }
      #content {
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        opacity: 1;
        filter: blur(0px);
        transition:
          opacity 0.3s,
          filter 0.3s;
        pointer-events: auto;
      }
    </style>
    <!-- Page Element Content -->
    <div id="content">${template}</div>
    <slot class="serviceSlot" id="dialog"></slot>
    <slot class="serviceSlot" id="tooltip"></slot>
  `;
}
export { _html as html };

export class KatapultPageElement extends KatapultElement {
  get content() {
    return this.$$('#content');
  }

  get isKatapultPageElement() {
    return true;
  }

  setOverlayDepth(depth) {
    if (!this.content) return;
    if (depth > 0) {
      this.content.style.filter = `blur(${depth * 2}px)`;
      this.content.style.pointerEvents = 'none';
      this.content.style.opacity = 0.5;
    } else {
      this.content.style.filter = `blur(0px)`;
      this.content.style.pointerEvents = 'auto';
      this.content.style.opacity = 1;
    }
  }

  serviceSlot(name) {
    return this.$$(`slot.serviceSlot[id="${name}"]`);
  }

  constructor() {
    super();
    // Set the page id.
    this.id = 'pageElement';
  }

  ready() {
    super.ready();
  }
}
